var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Game',{attrs:{"id":"game3","hud-template":_vm.Hud},scopedSlots:_vm._u([{key:"error",fn:function(){return [_vm._v(" Martin Luther wurde von den Verfolgern eingeholt und festgenommen."),_c('br'),_vm._v(" Was möchtest du tun? ")]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }